import React from 'react'
import useHandleClickOutside from '../HandleClickOutside/HandleClickOutside';
import { XIcon } from '@heroicons/react/outline'

const Modal = ({ modalContent, setIsOpen, width }) => {
    let domNode = useHandleClickOutside(() => {
        // setIsOpen(false);
    })
    return (
        <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-[100] animate-fadeIn px-6'>
            <div ref={domNode} className={`relative max-h-[calc(100vh-50px)] bg-white rounded border-2 border-blueSecondary animate-modal shadow-2xl ${width ? 'ima' : 'nema'} ${width ? width : 'w-[500px] md:max-w-[600px] lg:max-w-[700px]'}`}>
                <button className='absolute -top-5 -right-5 p-1.5 rounded-full bg-white border-2 border-blueSecondary hover:rotate-90 transition' onClick={() => setIsOpen(false)}><XIcon className='w-5 h-5 md:w-7 md:h-7 text-blueSecondary' /></button>
                <div className="max-h-[calc(100vh-54px)] h-full pb-6 overflow-y-auto">
                    {modalContent}
                </div>
            </div>
        </div>
    )
}

export default Modal
